import { PctHttpErrorResponse } from '../pct-http-error-response';
import type { TranslateAbleText } from '@pct-ng/i18n';

export interface ResolvedFieldError {
  path: string;
  msg: TranslateAbleText;
}

export type FieldErrorResolver<ERRORS = any> = (fieldErrors: ERRORS) => ResolvedFieldError[];

export class FieldError<ERRORS = any> extends PctHttpErrorResponse {
  readonly #fieldErrors: ERRORS;
  get fieldErrors(): ERRORS {
    return this.#fieldErrors;
  }

  constructor(
    fieldErrors: ERRORS,
    message: string,
    status: number,
    response: string,
    headers: {
      [key: string]: any;
    },
    originalError?: Error,
  ) {
    super(message, status, response, headers, originalError);
    this.#fieldErrors = fieldErrors;
  }
}
